import { DateTime } from 'luxon';
import { isNil } from 'lodash/fp';

export function generateTimeSeriesFromRange(dateRange) {
    const now = DateTime.utc();
    const rangeFrom = !isNil(dateRange?.rangeFrom) ? DateTime.fromISO(dateRange.rangeFrom) : null;
    const rangeTo = !isNil(dateRange?.rangeTo) ? DateTime.fromISO(dateRange.rangeTo) : null;

    if (!rangeFrom && !rangeTo) {
        return [[now, 0]];
    }
    if (rangeFrom && rangeTo) {
        return [
            [rangeFrom, 0],
            [rangeTo, 0]
        ];
    }
    if (rangeFrom) {
        return rangeFrom < now
            ? [
                  [rangeFrom, 0],
                  [now, 0]
              ]
            : [[rangeFrom, 0]];
    }
    if (rangeTo) {
        return [[rangeTo, 0]];
    }
}
